export default {
  carLicenseDetail: 'CarLicense Detail',
  revise: 'revise',
  back: 'back',
  state: 'state',
  CompanyNameOfBuilder: 'Company name',
  eMail: 'e-mail',
  number: 'Number',
  BoothNumber: 'Booth Number',
  Addressee: 'Addressee',
  ContactInformation: 'ContactInformation',
  Contact_Information: 'Contact information',
  postCode: 'post code',
  address: 'address',
  carLicenseApply: 'Car License Apply',
  add: 'add',
  carLicenseApplyList: 'CarLicense Apply List',
  ExhibitionName: 'Exhibition Name',
  carLicenseType: 'Type of car License',
  carLicenseNumber: 'Number of car License',
  ViewDetails: 'View Details',
  local: 'local',
  ForeignPort: 'Foreign port',
  submit: 'submit',
  ContactInfo: 'Contact information',
  name: 'name',
  phoneNumber: 'phoneNumber',
  plateNumber: 'plate number',
  remark: 'remark',
  operation: 'operation',
  next: 'next',
  addresss: 'address',
  HistoryFillInRecords: 'History Fill in Records',
  check: 'check',
  '本页面无法修改车证申请，如有所需点击': 'This page is unable to modify the vehicle license application, if you need to click',
  '车证申请': 'Application for Vehicle License',
  '进行修改': 'Modification',
  '上一步': 'Previous',
  '下一步': 'Next',
  '请输入公司名称': 'Please enter the name of the company.',
  '请输入邮箱': 'Please enter your mailbox',
  '请输入申请车证数量': 'Please enter the number of vehicle licenses you apply for.',
  '请输入车证信息回车查询': 'Please enter the vehicle license information for inquiry',
  '返回': 'back',
  '请输入展位号回车查询': 'Please enter booth number and return for inquiry.',
  'Excel导入': 'Excel Import',
  '请输入联系人姓名': 'Please enter the name of the contact person.',
  '请输入联系方式': 'Please enter your contact information.',
  '请输入正确的联系方式': 'Please enter the correct contact information.',
  '请输入车牌号': 'Please enter the license plate number.',
  '如有特殊情况请说明': 'If there is any special case, please explain.',
  '新增人员': 'Additional applications',
  '请输入收件人姓名': "Please enter the recipient's name",
  '请输入联系电话': 'Please enter a contact number.',
  '请输入邮编': 'Please enter your zip code',
  '请输入邮寄地址': 'Please enter your mailing address.',
  '下载工作人员资料模板': 'Download staff information template',
  '选择上传文件': 'Select upload file',
  '上传': 'upload',
  '姓名': 'name',
  '无': 'nothing',
  '请输入有效的邮箱': 'Please enter a valid mailbox',
  '请输入有效的手机号': 'Please enter a valid mobile phone number.',
  '创建成功': 'Create Success',
  '添加车证成功': 'Create Success',
  '提示': 'Tips',
  '是否确认提交': 'Confirmation of submission',
  '确定': 'Determine',
  '取消': 'cancel',
  '本地': 'local',
  '外埠': 'Foreign port',
  '男': 'male',
  '女': 'female',

  '车证归属地': 'Ownership of vehicle license',
  '本地车证': 'Local vehicle license',
  '外埠车证': 'Foreign car license',
  '展会举办地的车证即为本地车证': 'The vehicle license of the place where the exhibition is held is the local vehicle license',
  '非展会举办地的车证即为外埠车证': 'The vehicle license that is not the place where the exhibition is held is the foreign vehicle license',
  '通行许可证获取方式': 'How to obtain the permit',
  '身份证正面照片': 'Front photo of ID card',
  '驾驶证照片': "Driver's license photo",
  '行驶证照片': 'Driving license photo',
  '车牌号码': 'license plate',
  '车牌类型': 'License plate type',
  '车辆类型': 'Vehicle type',
  '请输入正确的车牌号': 'Please enter the correct license plate number',
  '货车证': 'Truck license',
  '小车证': 'Car certificate',
  '暂未开放该项证件的申请': 'Application for this certificate has not been opened yet',
  '领取方式': 'Collection method',
  '现场领取': 'Collect on site',
  '请在下方表格中添加展位号': 'Please add the booth number in the table below',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/carLicenseApply.js